var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333333 4.2333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.1168161,1.5181083e-4 A 0.40638699,0.40638699 0 0 0 1.7096673,0.40580357 V 1.7095185 H 0.40595292 A 0.40638699,0.40638699 0 0 0 7.1884308e-7,2.1166696 0.40638699,0.40638699 0 0 0 0.40595292,2.5226166 H 1.7096673 V 3.8263315 A 0.40638699,0.40638699 0 0 0 2.1168161,4.2331816 0.40638699,0.40638699 0 0 0 2.5227683,3.8263315 V 2.5226166 h 1.303415 A 0.40638699,0.40638699 0 0 0 4.2333327,2.1166696 0.40638699,0.40638699 0 0 0 3.8261833,1.7095185 H 2.5227683 V 0.40580357 A 0.40638699,0.40638699 0 0 0 2.1168161,1.5181083e-4 Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.ff5b824f37f3d8fdbcff1360424c18b1.svg";
export { ForwardRef as ReactComponent };